import { css } from '@emotion/core';

import bp from './breakpoints';
import * as colors from './colors';
import * as easing from './easings';
import * as form from './form';
import space from './space';
import * as text from './text';

const colorWhite = css`
  color: white !important;
`;

const hiddenXXL = css`
  @media (max-width: 374px) {
    display: none !important;
  }
`;

export { bp, colors, colorWhite, hiddenXXL, space, easing, text, form };
